import React, { useState, useEffect } from 'react';
import { useStyles } from "../styles";
import { useTranslation } from "react-i18next";
import { EnableTime } from "../types.d"
interface TimeInputs {
  time: { start: string, end: string },
  index: number,
  day: string,
  updateTimingArray: (key: string, index: number, value: EnableTime) => void;
}
//eslint-disable-next-line
export function TimeInputs({ time, index, day, updateTimingArray }: TimeInputs) {
  const [start, setStart] = useState<string>(time.start);
  const [end, setEnd] = useState<string>(time.end);
  const classes = useStyles();
  const { t } = useTranslation();
  function onChange(e: any) {
    const { value, name } = e.target;
    if (value.length === 5) {
      if (name === "start") {
        setStart(value);
      } else {
        setEnd(value);
      }
    }
  }
  function onBlur(e: any) {
    if (e.target.value === '') { e.target.type = 'text' }
  }
  function onFocus(e: any) {
    e.target.type = 'time'
  }
  useEffect(() => {
    updateTimingArray(day, index, { start: start, end: end })
    // eslint-disable-next-line
  }, [start, end])
  useEffect(() => {
    setStart(time.start);
    setEnd(time.end);
    // eslint-disable-next-line
  }, [time])
  return (
    <div className={classes.TimeInputs} data-component-name={`TIMING_INPUTS_${day}_${index}`}>
      <input name={"start"} type="text" value={start} placeholder={t("misc.start")} maxLength={5} onChange={onChange} onFocus={onFocus} onBlur={onBlur} />
      <input name={"end"} type="text" value={end} placeholder={t("misc.end")} maxLength={5} onChange={onChange} onFocus={onFocus} onBlur={onBlur} />
    </div>
  )
}
